export default __webpack_public_path__ + "static/media/titleLiif.6a3b13ad.webp";